module.exports = __webpack_public_path__ + "img/sand-rock-big-07.ce28dc23.png";